import { FC } from 'react';
import { useReviewCheckToggleContext } from '#baseMenu/components';

const ReviewCheckHolder: FC = () => {
  const { ReviewCheck, isLoaded } = useReviewCheckToggleContext();

  if (!isLoaded) {
    return null;
  }

  return <ReviewCheck />;
};

export { ReviewCheckHolder };
